/* eslint-disable no-plusplus */
const getStars = (value) => {
  let template = '';
  for (let i = 0; i < value; i++) {
    template += '<i class="icofont-star"></i>';
  }
  return template;
};

export default getStars;
